export default "__VITE_ASSET__c459acf5__"